<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-space-y-3">
      <div>
        <label class="required">{{ $t('wholesale.employee') }}</label>
        <!-- <a-select
					v-model="model.seller_id"
					:options="employeeList"
					:filterOption="
						(input, option) =>
							option.componentOptions.children[0].text
								.toLowerCase()
								.indexOf(input.toLowerCase()) >= 0
					"
					showSearch
					class="ts-w-full"
				></a-select> -->
        <a-select
          v-model="model.seller_id"
          show-search
          style="width: 100%"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :placeholder="$t('wholesale.customer')"
          @search="handleSaleSearch"
        >
          <a-select-option v-for="emp in employeeList" :key="emp.employee_id">
            {{ emp.employee_name_en }}
          </a-select-option>
        </a-select>
        <div class="validate" v-if="errors.has('seller_id')">
          {{ errors.first('seller_id') }}
        </div>
      </div>
      <div class="ts-space-y-3">
        <div>
          <label class="required">{{ $t('wholesale.customer') }}</label>
          <div class="ts-flex ts-items-center">
            <!-- <a-select
							v-model="model.customer_id"
							:filterOption="
								(input, option) =>
									option.componentOptions.children[0].text
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
							"
							showSearch
							:options="customerList"
							class="ts-w-full"
						></a-select> -->

            <a-select
              v-model="model.customer_id"
              show-search
              style="width: 100%"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :placeholder="$t('wholesale.customer')"
              @search="handleCustomerSearch"
            >
              <a-select-option v-for="c in customerList" :key="c.customer_id">
                {{ c.customer_name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="validate" v-if="errors.has('customer_id')">
            {{ errors.first('customer_id') }}
          </div>
        </div>
      </div>

      <div class="ts-space-y-3">
        <div>
          <label class="required">{{ $t('wholesale.owner') }}</label>
          <div class="ts-flex ts-items-center">
            <!-- <a-select
							v-model="model.customer_id"
							:filterOption="
								(input, option) =>
									option.componentOptions.children[0].text
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
							"
							showSearch
							:options="customerList"
							class="ts-w-full"
						></a-select> -->

            <a-select
              v-model="model.customer_id_ref"
              show-search
              style="width: 100%"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :placeholder="$t('wholesale.ownerList')"
              @search="handleOwnerSearch"
            >
              <a-select-option v-for="o in ownerList" :key="o.customer_id">
                {{ o.customer_name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="validate" v-if="errors.has('customer_id_ref')">
            {{ errors.first('customer_id_ref') }}
          </div>
        </div>
      </div>

      <div class="ts-space-y-3">
        <div class="ts-flex ts-justify-end ts-items-end ts-space-x-3">
          <ts-button @click.prevent="$emit('cancel')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button @click.prevent="onUpdate" color="primary">{{
            $t('update')
          }}</ts-button>
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'editMainInvoice',
  props: ['editData'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {
        seller_id: null,
        customer_id: null,
        customer_id_ref: null,
      },
      employeeList: [],
      customerList: [],
      ownerList: [],
    }
  },
  created() {
    this.setData()
  },
  methods: {
    ...mapActions('wholesale/operation', ['getFormViewData', 'updateMain']),
    handleCustomerSearch: debounce(function (value) {
      this.loading = true
      this.getFormViewData({
        params: {
          fnName: 'customer',
          search_customer: value,
        },
      })
        .then((response) => {
          this.customerList = response.data.customer
        })
        .finally(() => (this.loading = false))
    }, 1000),
    handleOwnerSearch: debounce(function (value) {
      this.loading = true
      this.getFormViewData({
        params: {
          fnName: 'customer',
          search_customer: value,
        },
      })
        .then((response) => {
          this.ownerList = response.data.customer
        })
        .finally(() => (this.loading = false))
    }, 1000),
    handleSaleSearch: debounce(function (value) {
      this.loading = true
      this.getFormViewData({
        params: {
          fnName: 'sale',
          search_sale: value,
        },
      })
        .then((response) => {
          this.employeeList = response.data.sale
        })
        .finally(() => (this.loading = false))
    }, 1000),
    onUpdate() {
      this.loading = true
      this.errors = new Errors()
      this.updateMain({
        id: this.editData.stock_out_id,
        data: this.model,
      })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setData() {
      this.employeeList = []
      this.customerList = []

      this.customerList.push(this.editData.customer)

      this.employeeList.push(this.editData.sale)

      this.model.seller_id = this.editData.seller_id
      this.model.customer_id = this.editData.customer_id
    },
  },
}
</script>
